import Main from "@/views/common/main";
// 账户管理中心
export default [
  //'系统管理'
  {
    path: "/user",
    name: "user",
    meta: {
      icon: "ios-apps",
      title: "玩家管理",
    },
    component: Main,
    children: [
      // 活跃管理
      {
        path: "activePlayers",
        name: "user_activePlayers",
        meta: { title: "活跃玩家" },
        component: () => import("@/views/user/activePlayers.vue"),
      },
      // 红包管理
      {
        path: "redEnvelope",
        name: "user_redEnvelope",
        meta: { title: "红包管理" },
        component: () => import("@/views/user/redEnvelope.vue"),
      },
      // 标签管理
      {
        path: "labelManagement",
        name: "user_labelManagement",
        meta: { title: "标签管理" },
        component: () => import("@/views/user/labelManagement.vue"),
      },
      // 风险玩家白名单
      {
        path: "riskPlayerWhite",
        name: "user_riskPlayerWhite",
        meta: { title: "风险玩家白名单" },
        component: () => import("@/views/user/riskPlayerWhite.vue"),
      },
      // 玩家管理
      {
        path: "playerManager",
        name: "user_playerManager",
        meta: { title: "玩家管理" },
        component: () => import("@/views/user/playerManager/playerManager.vue"),
      },
      // 增减金额
      {
        path: "changePoint",
        name: "user_changePoint",
        meta: { title: "玩家管理" },
        component: () => import("@/views/user/changePoint/changePoint.vue"),
      },
    ],
  },
];
// 数据报表
